<template>
  <div class="admin-vacaciones">
    <b-card no-body>
      <b-tabs v-model="tabActivo" card>
        <!-- Tab Calendario General -->
        <b-tab title="Calendario">
          <calendario-general ref="calendarioGeneral" />
        </b-tab>

        <!-- Tab Solicitudes -->
        <b-tab>
          <template #title>
            Solicitudes
            <b-badge v-if="solicitudesPendientes.length > 0" variant="danger" pill class="ml-50">
              {{ solicitudesPendientes.length }}
            </b-badge>
          </template>
          <solicitudes-pendientes />
        </b-tab>

        <!-- Tab Calendarios -->
        <b-tab title="Calendarios">
          <calendarios-tab @ver-festivos="verFestivos" />
        </b-tab>

        <!-- Tab Asignaciones -->
        <b-tab title="Asignaciones">
          <asignaciones-tab />
        </b-tab>

        <!-- Tab Convenios -->
        <b-tab title="Convenios">
          <convenios-tab />
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- Modal Festivos -->
    <b-modal
      v-model="mostrarModalFestivos"
      :title="`Festivos: ${calendarioFestivos ? calendarioFestivos.nombre : ''}`"
      size="lg"
      hide-footer
      centered
      scrollable
    >
      <festivos-tab
        v-if="calendarioFestivos"
        :calendario="calendarioFestivos"
        @volver="cerrarModalFestivos"
      />
    </b-modal>
  </div>
</template>

<script>
import { BCard, BTabs, BTab, BBadge, BModal } from 'bootstrap-vue'
import { mapState, mapActions } from 'vuex'
import CalendarioGeneral from './CalendarioGeneral.vue'
import SolicitudesPendientes from './SolicitudesPendientes.vue'
import CalendariosTab from './Calendarios.vue'
import FestivosTab from './Festivos.vue'
import AsignacionesTab from './Asignaciones.vue'
import ConveniosTab from './Convenios.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    BBadge,
    BModal,
    CalendarioGeneral,
    SolicitudesPendientes,
    CalendariosTab,
    FestivosTab,
    AsignacionesTab,
    ConveniosTab,
  },

  data() {
    return {
      tabActivo: 0,
      calendarioFestivos: null,
      mostrarModalFestivos: false,
    }
  },

  computed: {
    ...mapState('vacaciones', ['solicitudesPendientes']),
  },

  watch: {
    '$route.query.tab': {
      immediate: true,
      handler(val) {
        if (val === 'solicitudes') {
          this.tabActivo = 1
        }
      }
    },
    tabActivo(val) {
      if (val === 0) {
        this.$nextTick(function() {
          var cal = this.$refs.calendarioGeneral
          if (cal && cal.$refs.refCalendar) {
            var api = cal.$refs.refCalendar.getApi()
            if (api) api.updateSize()
          }
        })
      }
    },
  },

  mounted() {
    this.fetchSolicitudesPendientes()
  },

  methods: {
    ...mapActions('vacaciones', ['fetchSolicitudesPendientes']),

    verFestivos(calendario) {
      this.calendarioFestivos = calendario
      this.mostrarModalFestivos = true
    },

    cerrarModalFestivos() {
      this.mostrarModalFestivos = false
      this.calendarioFestivos = null
    },
  },
}
</script>
